import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Button.module.scss';

const Button = ({
  title,
  className,
  iconClassName,
  onClick,
  disabled,
  processing,
  color,
  fullWidth,
  ...props
}) => (
  <button
    disabled={disabled || processing}
    className={cn(styles.button, className, styles[color], {
      [styles.processing]: processing,
      [styles.hasIcon]: !!iconClassName,
      [styles.fullWidth]: fullWidth,
    })}
    type="button"
    onClick={onClick}
    {...props}
  >
    {iconClassName && !processing && (<i className={iconClassName} />)}
    {processing && (<div className={cn('spinner-border text-light', styles.spinner)} />)}
    <span>{title}</span>
  </button>
);

Button.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  processing: PropTypes.bool,
  fullWidth: PropTypes.bool,
  color: PropTypes.oneOf(['default', 'red', 'green']),
};

Button.defaultProps = {
  className: '',
  iconClassName: null,
  onClick() {},
  disabled: false,
  processing: false,
  fullWidth: false,
  color: 'default',
};

export default Button;
